import RegionModel from 'Models/RegionModel';

const ServerModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW -> RegionMap::REGION_ID_EU
ServerModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: 'Aegwynn',
  },
  {
    id: 2,
    title: 'Aerie Peak',
  },
  {
    id: 3,
    title: 'Agamaggan',
  },
  {
    id: 4,
    title: 'Aggra (Português)',
  },
  {
    id: 5,
    title: 'Aggramar',
  },
  {
    id: 6,
    title: 'Ahn\'Qiraj',
  },
  {
    id: 7,
    title: 'Al\'Akir',
  },
  {
    id: 8,
    title: 'Alexstrasza',
  },
  {
    id: 9,
    title: 'Alleria',
  },
  {
    id: 10,
    title: 'Alonsus',
  },
  {
    id: 11,
    title: 'Aman\'Thul',
  },
  {
    id: 12,
    title: 'Ambossar',
  },
  {
    id: 13,
    title: 'Anachronos',
  },
  {
    id: 14,
    title: 'Anetheron',
  },
  {
    id: 15,
    title: 'Antonidas',
  },
  {
    id: 16,
    title: 'Anub\'arak',
  },
  {
    id: 17,
    title: 'Arak-arahm',
  },
  {
    id: 18,
    title: 'Arathi',
  },
  {
    id: 19,
    title: 'Arathor',
  },
  {
    id: 20,
    title: 'Archimonde',
  },
  {
    id: 21,
    title: 'Area 52',
  },
  {
    id: 22,
    title: 'Argent Dawn',
  },
  {
    id: 23,
    title: 'Arthas',
  },
  {
    id: 24,
    title: 'Arygos',
  },
  {
    id: 25,
    title: 'Aszune',
  },
  {
    id: 26,
    title: 'Auchindoun',
  },
  {
    id: 27,
    title: 'Azjol-Nerub',
  },
  {
    id: 28,
    title: 'Azshara',
  },
  {
    id: 29,
    title: 'Azuremyst',
  },
  {
    id: 30,
    title: 'Baelgun',
  },
  {
    id: 31,
    title: 'Balnazzar',
  },
  {
    id: 32,
    title: 'Blackhand',
  },
  {
    id: 33,
    title: 'Blackmoore',
  },
  {
    id: 34,
    title: 'Blackrock',
  },
  {
    id: 35,
    title: 'Blade\'s Edge',
  },
  {
    id: 36,
    title: 'Bladefist',
  },
  {
    id: 37,
    title: 'Bloodfeather',
  },
  {
    id: 38,
    title: 'Bloodhoof',
  },
  {
    id: 39,
    title: 'Bloodscalp',
  },
  {
    id: 40,
    title: 'Blutkessel',
  },
  {
    id: 41,
    title: 'Boulderfist',
  },
  {
    id: 42,
    title: 'Bronze Dragonflight',
  },
  {
    id: 43,
    title: 'Bronzebeard',
  },
  {
    id: 44,
    title: 'Burning Blade',
  },
  {
    id: 45,
    title: 'Burning Legion',
  },
  {
    id: 46,
    title: 'Burning Steppes',
  },
  {
    id: 47,
    title: 'C\'Thun',
  },
  {
    id: 48,
    title: 'Chamber of Aspects',
  },
  {
    id: 49,
    title: 'Chants éternels',
  },
  {
    id: 50,
    title: 'Cho\'gall',
  },
  {
    id: 51,
    title: 'Chromaggus',
  },
  {
    id: 269,
    title: 'Colinas Pardas',
  },
  {
    id: 52,
    title: 'Confrérie du Thorium',
  },
  {
    id: 53,
    title: 'Conseil des Ombres',
  },
  {
    id: 54,
    title: 'Crushridge',
  },
  {
    id: 55,
    title: 'Culte de la Rive noire',
  },
  {
    id: 56,
    title: 'Daggerspine',
  },
  {
    id: 57,
    title: 'Dalaran',
  },
  {
    id: 58,
    title: 'Dalvengyr',
  },
  {
    id: 59,
    title: 'Darkmoon Faire',
  },
  {
    id: 60,
    title: 'Darksorrow',
  },
  {
    id: 61,
    title: 'Darkspear',
  },
  {
    id: 62,
    title: 'Das Konsortium',
  },
  {
    id: 63,
    title: 'Das Syndikat',
  },
  {
    id: 64,
    title: 'Deathwing',
  },
  {
    id: 65,
    title: 'Defias Brotherhood',
  },
  {
    id: 66,
    title: 'Dentarg',
  },
  {
    id: 67,
    title: 'Der Mithrilorden',
  },
  {
    id: 68,
    title: 'Der Rat von Dalaran',
  },
  {
    id: 69,
    title: 'Der abyssische Rat',
  },
  {
    id: 70,
    title: 'Destromath',
  },
  {
    id: 71,
    title: 'Dethecus',
  },
  {
    id: 72,
    title: 'Die Aldor',
  },
  {
    id: 73,
    title: 'Die Arguswacht',
  },
  {
    id: 74,
    title: 'Die Nachtwache',
  },
  {
    id: 75,
    title: 'Die Silberne Hand',
  },
  {
    id: 76,
    title: 'Die Todeskrallen',
  },
  {
    id: 77,
    title: 'Die ewige Wacht',
  },
  {
    id: 78,
    title: 'Doomhammer',
  },
  {
    id: 79,
    title: 'Draenor',
  },
  {
    id: 80,
    title: 'Dragonblight',
  },
  {
    id: 81,
    title: 'Dragonmaw',
  },
  {
    id: 82,
    title: 'Drak\'thul',
  },
  {
    id: 83,
    title: 'Drek\'Thar',
  },
  {
    id: 84,
    title: 'Dun Modr',
  },
  {
    id: 85,
    title: 'Dun Morogh',
  },
  {
    id: 86,
    title: 'Dunemaul',
  },
  {
    id: 87,
    title: 'Durotan',
  },
  {
    id: 88,
    title: 'Earthen Ring',
  },
  {
    id: 89,
    title: 'Echsenkessel',
  },
  {
    id: 90,
    title: 'Eitrigg',
  },
  {
    id: 91,
    title: 'Eldre\'Thalas',
  },
  {
    id: 92,
    title: 'Elune',
  },
  {
    id: 93,
    title: 'Emerald Dream',
  },
  {
    id: 94,
    title: 'Emeriss',
  },
  {
    id: 95,
    title: 'Eonar',
  },
  {
    id: 96,
    title: 'Eredar',
  },
  {
    id: 97,
    title: 'Executus',
  },
  {
    id: 98,
    title: 'Exodar',
  },
  {
    id: 99,
    title: 'Festung der Stürme',
  },
  {
    id: 100,
    title: 'Forscherliga',
  },
  {
    id: 101,
    title: 'Frostmane',
  },
  {
    id: 102,
    title: 'Frostmourne',
  },
  {
    id: 103,
    title: 'Frostwhisper',
  },
  {
    id: 104,
    title: 'Frostwolf',
  },
  {
    id: 105,
    title: 'Garona',
  },
  {
    id: 106,
    title: 'Garrosh',
  },
  {
    id: 107,
    title: 'Genjuros',
  },
  {
    id: 108,
    title: 'Ghostlands',
  },
  {
    id: 109,
    title: 'Gilneas',
  },
  {
    id: 110,
    title: 'Gorgonnash',
  },
  {
    id: 111,
    title: 'Grim Batol',
  },
  {
    id: 112,
    title: 'Gul\'dan',
  },
  {
    id: 113,
    title: 'Hakkar',
  },
  {
    id: 114,
    title: 'Haomarush',
  },
  {
    id: 115,
    title: 'Hellfire',
  },
  {
    id: 116,
    title: 'Hellscream',
  },
  {
    id: 117,
    title: 'Hyjal',
  },
  {
    id: 118,
    title: 'Illidan',
  },
  {
    id: 119,
    title: 'Jaedenar',
  },
  {
    id: 120,
    title: 'Kael\'thas',
  },
  {
    id: 121,
    title: 'Karazhan',
  },
  {
    id: 122,
    title: 'Kargath',
  },
  {
    id: 123,
    title: 'Kazzak',
  },
  {
    id: 124,
    title: 'Kel\'Thuzad',
  },
  {
    id: 125,
    title: 'Khadgar',
  },
  {
    id: 126,
    title: 'Khaz Modan',
  },
  {
    id: 127,
    title: 'Khaz\'goroth',
  },
  {
    id: 128,
    title: 'Kil\'jaeden',
  },
  {
    id: 129,
    title: 'Kilrogg',
  },
  {
    id: 130,
    title: 'Kirin Tor',
  },
  {
    id: 131,
    title: 'Kor\'gall',
  },
  {
    id: 132,
    title: 'Krag\'jin',
  },
  {
    id: 133,
    title: 'Krasus',
  },
  {
    id: 134,
    title: 'Kul Tiras',
  },
  {
    id: 135,
    title: 'Kult der Verdammten',
  },
  {
    id: 136,
    title: 'La Croisade écarlate',
  },
  {
    id: 137,
    title: 'Laughing Skull',
  },
  {
    id: 138,
    title: 'Les Clairvoyants',
  },
  {
    id: 139,
    title: 'Les Sentinelles',
  },
  {
    id: 140,
    title: 'Lightbringer',
  },
  {
    id: 141,
    title: 'Lightning\'s Blade',
  },
  {
    id: 142,
    title: 'Lordaeron',
  },
  {
    id: 143,
    title: 'Los Errantes',
  },
  {
    id: 144,
    title: 'Lothar',
  },
  {
    id: 145,
    title: 'Madmortem',
  },
  {
    id: 146,
    title: 'Magtheridon',
  },
  {
    id: 147,
    title: 'Mal\'Ganis',
  },
  {
    id: 148,
    title: 'Malfurion',
  },
  {
    id: 149,
    title: 'Malorne',
  },
  {
    id: 150,
    title: 'Malygos',
  },
  {
    id: 151,
    title: 'Mannoroth',
  },
  {
    id: 152,
    title: 'Marécage de Zangar',
  },
  {
    id: 153,
    title: 'Mazrigos',
  },
  {
    id: 154,
    title: 'Medivh',
  },
  {
    id: 155,
    title: 'Minahonda',
  },
  {
    id: 156,
    title: 'Moonglade',
  },
  {
    id: 157,
    title: 'Mug\'thol',
  },
  {
    id: 158,
    title: 'Nagrand',
  },
  {
    id: 159,
    title: 'Nathrezim',
  },
  {
    id: 160,
    title: 'Naxxramas',
  },
  {
    id: 161,
    title: 'Nazjatar',
  },
  {
    id: 162,
    title: 'Nefarian',
  },
  {
    id: 163,
    title: 'Nemesis',
  },
  {
    id: 164,
    title: 'Neptulon',
  },
  {
    id: 165,
    title: 'Ner\'zhul',
  },
  {
    id: 166,
    title: 'Nera\'thor',
  },
  {
    id: 167,
    title: 'Nethersturm',
  },
  {
    id: 168,
    title: 'Nordrassil',
  },
  {
    id: 169,
    title: 'Norgannon',
  },
  {
    id: 170,
    title: 'Nozdormu',
  },
  {
    id: 171,
    title: 'Onyxia',
  },
  {
    id: 172,
    title: 'Outland',
  },
  {
    id: 173,
    title: 'Perenolde',
  },
  {
    id: 174,
    title: 'Pozzo dell\'Eternità',
  },
  {
    id: 175,
    title: 'Proudmoore',
  },
  {
    id: 176,
    title: 'Quel\'Thalas',
  },
  {
    id: 177,
    title: 'Ragnaros',
  },
  {
    id: 178,
    title: 'Rajaxx',
  },
  {
    id: 179,
    title: 'Rashgarroth',
  },
  {
    id: 180,
    title: 'Ravencrest',
  },
  {
    id: 181,
    title: 'Ravenholdt',
  },
  {
    id: 182,
    title: 'Rexxar',
  },
  {
    id: 183,
    title: 'Runetotem',
  },
  {
    id: 184,
    title: 'Sanguino',
  },
  {
    id: 185,
    title: 'Sargeras',
  },
  {
    id: 186,
    title: 'Saurfang',
  },
  {
    id: 187,
    title: 'Scarshield Legion',
  },
  {
    id: 188,
    title: 'Sen\'jin',
  },
  {
    id: 189,
    title: 'Shadowsong',
  },
  {
    id: 190,
    title: 'Shattered Halls',
  },
  {
    id: 191,
    title: 'Shattered Hand',
  },
  {
    id: 192,
    title: 'Shattrath',
  },
  {
    id: 193,
    title: 'Shen\'dralar',
  },
  {
    id: 194,
    title: 'Silvermoon',
  },
  {
    id: 195,
    title: 'Sinstralis',
  },
  {
    id: 196,
    title: 'Skullcrusher',
  },
  {
    id: 197,
    title: 'Spinebreaker',
  },
  {
    id: 198,
    title: 'Spirestone',
  },
  {
    id: 199,
    title: 'Sporeggar',
  },
  {
    id: 200,
    title: 'Steamwheedle Cartel',
  },
  {
    id: 201,
    title: 'Stormrage',
  },
  {
    id: 202,
    title: 'Stormreaver',
  },
  {
    id: 203,
    title: 'Stormscale',
  },
  {
    id: 204,
    title: 'Sunstrider',
  },
  {
    id: 205,
    title: 'Suramar',
  },
  {
    id: 206,
    title: 'Sylvanas',
  },
  {
    id: 207,
    title: 'Taerar',
  },
  {
    id: 208,
    title: 'Talnivarr',
  },
  {
    id: 209,
    title: 'Tarren Mill',
  },
  {
    id: 210,
    title: 'Teldrassil',
  },
  {
    id: 211,
    title: 'Temple noir',
  },
  {
    id: 212,
    title: 'Terenas',
  },
  {
    id: 213,
    title: 'Terokkar',
  },
  {
    id: 214,
    title: 'Terrordar',
  },
  {
    id: 215,
    title: 'The Maelstrom',
  },
  {
    id: 216,
    title: 'The Sha\'tar',
  },
  {
    id: 217,
    title: 'The Venture Co',
  },
  {
    id: 218,
    title: 'Theradras',
  },
  {
    id: 219,
    title: 'Thrall',
  },
  {
    id: 220,
    title: 'Throk\'Feroth',
  },
  {
    id: 221,
    title: 'Thunderhorn',
  },
  {
    id: 222,
    title: 'Tichondrius',
  },
  {
    id: 223,
    title: 'Tirion',
  },
  {
    id: 224,
    title: 'Todeswache',
  },
  {
    id: 225,
    title: 'Trollbane',
  },
  {
    id: 226,
    title: 'Turalyon',
  },
  {
    id: 227,
    title: 'Twilight\'s Hammer',
  },
  {
    id: 228,
    title: 'Twisting Nether',
  },
  {
    id: 229,
    title: 'Tyrande',
  },
  {
    id: 230,
    title: 'Uldaman',
  },
  {
    id: 231,
    title: 'Ulduar',
  },
  {
    id: 232,
    title: 'Uldum',
  },
  {
    id: 233,
    title: 'Un\'Goro',
  },
  {
    id: 234,
    title: 'Varimathras',
  },
  {
    id: 235,
    title: 'Vashj',
  },
  {
    id: 236,
    title: 'Vek\'lor',
  },
  {
    id: 237,
    title: 'Vek\'nilash',
  },
  {
    id: 238,
    title: 'Vol\'jin',
  },
  {
    id: 268,
    title: 'Well of Eternity',
  },
  {
    id: 239,
    title: 'Wildhammer',
  },
  {
    id: 240,
    title: 'Wrathbringer',
  },
  {
    id: 241,
    title: 'Xavius',
  },
  {
    id: 242,
    title: 'Ysera',
  },
  {
    id: 243,
    title: 'Ysondre',
  },
  {
    id: 244,
    title: 'Zenedar',
  },
  {
    id: 245,
    title: 'Zirkel des Cenarius',
  },
  {
    id: 246,
    title: 'Zul\'jin',
  },
  {
    id: 247,
    title: 'Zuluhed',
  },
  {
    id: 248,
    title: 'Азурегос',
  },
  {
    id: 249,
    title: 'Борейская тундра',
  },
  {
    id: 250,
    title: 'Вечная Песня',
  },
  {
    id: 251,
    title: 'Галакронд',
  },
  {
    id: 252,
    title: 'Голдринн',
  },
  {
    id: 253,
    title: 'Гордунни',
  },
  {
    id: 254,
    title: 'Гром',
  },
  {
    id: 255,
    title: 'Дракономор',
  },
  {
    id: 256,
    title: 'Король-лич',
  },
  {
    id: 257,
    title: 'Пиратская Бухта',
  },
  {
    id: 258,
    title: 'Подземье',
  },
  {
    id: 259,
    title: 'Разувий',
  },
  {
    id: 260,
    title: 'Ревущий фьорд',
  },
  {
    id: 261,
    title: 'Свежеватель Душ',
  },
  {
    id: 262,
    title: 'Седогрив',
  },
  {
    id: 263,
    title: 'Страж Смерти',
  },
  {
    id: 264,
    title: 'Термоштепсель',
  },
  {
    id: 265,
    title: 'Ткач Смерти',
  },
  {
    id: 266,
    title: 'Черный Шрам',
  },
  {
    id: 267,
    title: 'Ясеневый лес',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW -> RegionMap::REGION_ID_USA
ServerModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: 'Aegwynn',
  },
  {
    id: 2,
    title: 'Aerie Peak',
  },
  {
    id: 3,
    title: 'Agamaggan',
  },
  {
    id: 4,
    title: 'Aggramar',
  },
  {
    id: 5,
    title: 'Akama',
  },
  {
    id: 6,
    title: 'Alexstrasza',
  },
  {
    id: 7,
    title: 'Alleria',
  },
  {
    id: 8,
    title: 'Altar of Storms',
  },
  {
    id: 9,
    title: 'Alterac Mountains',
  },
  {
    id: 10,
    title: 'Aman\'Thul',
  },
  {
    id: 11,
    title: 'Andorhal',
  },
  {
    id: 12,
    title: 'Anetheron',
  },
  {
    id: 13,
    title: 'Antonidas',
  },
  {
    id: 14,
    title: 'Anub\'arak',
  },
  {
    id: 15,
    title: 'Anvilmar',
  },
  {
    id: 16,
    title: 'Arathor',
  },
  {
    id: 17,
    title: 'Archimonde',
  },
  {
    id: 18,
    title: 'Area 52',
  },
  {
    id: 247,
    title: 'Argent Dawn',
  },
  {
    id: 19,
    title: 'Arthas',
  },
  {
    id: 20,
    title: 'Arygos',
  },
  {
    id: 256,
    title: 'Auchindoun',
  },
  {
    id: 21,
    title: 'Azgalor',
  },
  {
    id: 22,
    title: 'Azjol-Nerub',
  },
  {
    id: 23,
    title: 'Azralon',
  },
  {
    id: 24,
    title: 'Azshara',
  },
  {
    id: 25,
    title: 'Azuremyst',
  },
  {
    id: 26,
    title: 'Baelgun',
  },
  {
    id: 27,
    title: 'Balnazzar',
  },
  {
    id: 28,
    title: 'Barthilas',
  },
  {
    id: 29,
    title: 'Blackhand',
  },
  {
    id: 30,
    title: 'Blackrock',
  },
  {
    id: 31,
    title: 'Blackwater Raiders',
  },
  {
    id: 32,
    title: 'Blackwing Lair',
  },
  {
    id: 248,
    title: 'Black Dragonflight',
  },
  {
    id: 33,
    title: 'Blade\'s Edge',
  },
  {
    id: 34,
    title: 'Bladefist',
  },
  {
    id: 35,
    title: 'Bleeding Hollow',
  },
  {
    id: 36,
    title: 'Blood Furnace',
  },
  {
    id: 37,
    title: 'Bloodhoof',
  },
  {
    id: 38,
    title: 'Bloodscalp',
  },
  {
    id: 39,
    title: 'Bonechewer',
  },
  {
    id: 40,
    title: 'Borean Tundra',
  },
  {
    id: 41,
    title: 'Boulderfist',
  },
  {
    id: 42,
    title: 'Bronzebeard',
  },
  {
    id: 43,
    title: 'Burning Blade',
  },
  {
    id: 44,
    title: 'Burning Legion',
  },
  {
    id: 45,
    title: 'Caelestrasz',
  },
  {
    id: 46,
    title: 'Cairne',
  },
  {
    id: 249,
    title: 'Cenarion Circle',
  },
  {
    id: 47,
    title: 'Cenarius',
  },
  {
    id: 48,
    title: 'Cho\'gall',
  },
  {
    id: 49,
    title: 'Chromaggus',
  },
  {
    id: 50,
    title: 'Coilfang',
  },
  {
    id: 51,
    title: 'Crushridge',
  },
  {
    id: 52,
    title: 'Daggerspine',
  },
  {
    id: 53,
    title: 'Dalaran',
  },
  {
    id: 54,
    title: 'Dalvengyr',
  },
  {
    id: 55,
    title: 'Dark Iron',
  },
  {
    id: 56,
    title: 'Darkspear',
  },
  {
    id: 57,
    title: 'Darrowmere',
  },
  {
    id: 58,
    title: 'Dath\'Remar',
  },
  {
    id: 59,
    title: 'Dawnbringer',
  },
  {
    id: 252,
    title: 'Deathwing',
  },
  {
    id: 60,
    title: 'Demon Soul',
  },
  {
    id: 61,
    title: 'Dentarg',
  },
  {
    id: 62,
    title: 'Destromath',
  },
  {
    id: 63,
    title: 'Dethecus',
  },
  {
    id: 64,
    title: 'Detheroc',
  },
  {
    id: 65,
    title: 'Doomhammer',
  },
  {
    id: 66,
    title: 'Draenor',
  },
  {
    id: 67,
    title: 'Dragonblight',
  },
  {
    id: 68,
    title: 'Dragonmaw',
  },
  {
    id: 69,
    title: 'Drak\'Tharon',
  },
  {
    id: 70,
    title: 'Drak\'thul',
  },
  {
    id: 71,
    title: 'Draka',
  },
  {
    id: 72,
    title: 'Drakkari',
  },
  {
    id: 73,
    title: 'Dreadmaul',
  },
  {
    id: 74,
    title: 'Drenden',
  },
  {
    id: 75,
    title: 'Dunemaul',
  },
  {
    id: 76,
    title: 'Durotan',
  },
  {
    id: 77,
    title: 'Duskwood',
  },
  {
    id: 253,
    title: 'Earthen Ring',
  },
  {
    id: 78,
    title: 'Echo Isles',
  },
  {
    id: 79,
    title: 'Eitrigg',
  },
  {
    id: 80,
    title: 'Eldre\'Thalas',
  },
  {
    id: 81,
    title: 'Elune',
  },
  {
    id: 82,
    title: 'Emerald Dream',
  },
  {
    id: 83,
    title: 'Eonar',
  },
  {
    id: 84,
    title: 'Eredar',
  },
  {
    id: 85,
    title: 'Executus',
  },
  {
    id: 86,
    title: 'Exodar',
  },
  {
    id: 263,
    title: 'Fastriders',
  },
  {
    id: 87,
    title: 'Feathermoon',
  },
  {
    id: 88,
    title: 'Fenris',
  },
  {
    id: 89,
    title: 'Firetree',
  },
  {
    id: 90,
    title: 'Fizzcrank',
  },
  {
    id: 91,
    title: 'Frostmane',
  },
  {
    id: 92,
    title: 'Frostmourne',
  },
  {
    id: 93,
    title: 'Frostwolf',
  },
  {
    id: 94,
    title: 'Galakrond',
  },
  {
    id: 95,
    title: 'Gallywix',
  },
  {
    id: 96,
    title: 'Garithos',
  },
  {
    id: 97,
    title: 'Garona',
  },
  {
    id: 98,
    title: 'Garrosh',
  },
  {
    id: 99,
    title: 'Ghostlands',
  },
  {
    id: 100,
    title: 'Gilneas',
  },
  {
    id: 101,
    title: 'Gnomeregan',
  },
  {
    id: 102,
    title: 'Goldrinn',
  },
  {
    id: 103,
    title: 'Gorefiend',
  },
  {
    id: 104,
    title: 'Gorgonnash',
  },
  {
    id: 254,
    title: 'Greymane',
  },
  {
    id: 105,
    title: 'Grizzly Hills',
  },
  {
    id: 106,
    title: 'Gul\'dan',
  },
  {
    id: 107,
    title: 'Gundrak',
  },
  {
    id: 108,
    title: 'Gurubashi',
  },
  {
    id: 109,
    title: 'Hakkar',
  },
  {
    id: 110,
    title: 'Haomarush',
  },
  {
    id: 111,
    title: 'Hellscream',
  },
  {
    id: 112,
    title: 'Hydraxis',
  },
  {
    id: 113,
    title: 'Hyjal',
  },
  {
    id: 114,
    title: 'Icecrown',
  },
  {
    id: 115,
    title: 'Illidan',
  },
  {
    id: 116,
    title: 'Jaedenar',
  },
  {
    id: 117,
    title: 'Jubei\'Thos',
  },
  {
    id: 118,
    title: 'Kael\'thas',
  },
  {
    id: 257,
    title: 'Kalecgos',
  },
  {
    id: 119,
    title: 'Kargath',
  },
  {
    id: 120,
    title: 'Kel\'Thuzad',
  },
  {
    id: 250,
    title: 'Khadgar',
  },
  {
    id: 121,
    title: 'Khaz Modan',
  },
  {
    id: 122,
    title: 'Khaz\'goroth',
  },
  {
    id: 123,
    title: 'Kil\'jaeden',
  },
  {
    id: 124,
    title: 'Kilrogg',
  },
  {
    id: 125,
    title: 'Kirin Tor',
  },
  {
    id: 126,
    title: 'Korgath',
  },
  {
    id: 127,
    title: 'Korialstrasz',
  },
  {
    id: 128,
    title: 'Kul Tiras',
  },
  {
    id: 129,
    title: 'Laughing Skull',
  },
  {
    id: 130,
    title: 'Lethon',
  },
  {
    id: 131,
    title: 'Lightbringer',
  },
  {
    id: 132,
    title: 'Lightning\'s Blade',
  },
  {
    id: 133,
    title: 'Lightninghoof',
  },
  {
    id: 134,
    title: 'Llane',
  },
  {
    id: 135,
    title: 'Lothar',
  },
  {
    id: 136,
    title: 'Madoran',
  },
  {
    id: 137,
    title: 'Maelstrom',
  },
  {
    id: 138,
    title: 'Magtheridon',
  },
  {
    id: 258,
    title: 'Maiev',
  },
  {
    id: 139,
    title: 'Mal\'Ganis',
  },
  {
    id: 140,
    title: 'Malfurion',
  },
  {
    id: 141,
    title: 'Malorne',
  },
  {
    id: 142,
    title: 'Malygos',
  },
  {
    id: 143,
    title: 'Mannoroth',
  },
  {
    id: 144,
    title: 'Medivh',
  },
  {
    id: 259,
    title: 'Misha',
  },
  {
    id: 260,
    title: 'Mok\'nathal',
  },
  {
    id: 145,
    title: 'Moon Guard',
  },
  {
    id: 146,
    title: 'Moonrunner',
  },
  {
    id: 147,
    title: 'Mug\'thol',
  },
  {
    id: 261,
    title: 'Muradin',
  },
  {
    id: 148,
    title: 'Nagrand',
  },
  {
    id: 149,
    title: 'Nathrezim',
  },
  {
    id: 150,
    title: 'Nazgrel',
  },
  {
    id: 151,
    title: 'Nazjatar',
  },
  {
    id: 152,
    title: 'Nemesis',
  },
  {
    id: 153,
    title: 'Ner\'zhul',
  },
  {
    id: 154,
    title: 'Nesingwary',
  },
  {
    id: 155,
    title: 'Nordrassil',
  },
  {
    id: 156,
    title: 'Norgannon',
  },
  {
    id: 157,
    title: 'Onyxia',
  },
  {
    id: 158,
    title: 'Perenolde',
  },
  {
    id: 159,
    title: 'Proudmoore',
  },
  {
    id: 160,
    title: 'Quel\'Thalas',
  },
  {
    id: 161,
    title: 'Quel\'dorei',
  },
  {
    id: 162,
    title: 'Ragnaros',
  },
  {
    id: 163,
    title: 'Ravencrest',
  },
  {
    id: 164,
    title: 'Ravenholdt',
  },
  {
    id: 165,
    title: 'Rexxar',
  },
  {
    id: 166,
    title: 'Rivendare',
  },
  {
    id: 167,
    title: 'Runetotem',
  },
  {
    id: 168,
    title: 'Sargeras',
  },
  {
    id: 169,
    title: 'Saurfang',
  },
  {
    id: 170,
    title: 'Scarlet Crusade',
  },
  {
    id: 171,
    title: 'Scilla',
  },
  {
    id: 172,
    title: 'Sen\'jin',
  },
  {
    id: 173,
    title: 'Sentinels',
  },
  {
    id: 174,
    title: 'Shadow Council',
  },
  {
    id: 175,
    title: 'Shadowmoon',
  },
  {
    id: 176,
    title: 'Shadowsong',
  },
  {
    id: 177,
    title: 'Shandris',
  },
  {
    id: 178,
    title: 'Shattered Halls',
  },
  {
    id: 179,
    title: 'Shattered Hand',
  },
  {
    id: 180,
    title: 'Shu\'halo',
  },
  {
    id: 181,
    title: 'Silver Hand',
  },
  {
    id: 182,
    title: 'Silvermoon',
  },
  {
    id: 183,
    title: 'Sisters of Elune',
  },
  {
    id: 184,
    title: 'Skullcrusher',
  },
  {
    id: 185,
    title: 'Skywall',
  },
  {
    id: 186,
    title: 'Smolderthorn',
  },
  {
    id: 187,
    title: 'Spinebreaker',
  },
  {
    id: 188,
    title: 'Spirestone',
  },
  {
    id: 189,
    title: 'Staghelm',
  },
  {
    id: 190,
    title: 'Steamwheedle Cartel',
  },
  {
    id: 191,
    title: 'Stonemaul',
  },
  {
    id: 192,
    title: 'Stormrage',
  },
  {
    id: 193,
    title: 'Stormreaver',
  },
  {
    id: 194,
    title: 'Stormscale',
  },
  {
    id: 195,
    title: 'Suramar',
  },
  {
    id: 196,
    title: 'Tanaris',
  },
  {
    id: 262,
    title: 'Terenas',
  },
  {
    id: 197,
    title: 'Terokkar',
  },
  {
    id: 198,
    title: 'Thaurissan',
  },
  {
    id: 199,
    title: 'The Forgotten Coast',
  },
  {
    id: 200,
    title: 'The Scryers',
  },
  {
    id: 201,
    title: 'The Underbog',
  },
  {
    id: 202,
    title: 'The Venture Co',
  },
  {
    id: 203,
    title: 'Thorium Brotherhood',
  },
  {
    id: 204,
    title: 'Thrall',
  },
  {
    id: 205,
    title: 'Thunderhorn',
  },
  {
    id: 206,
    title: 'Thunderlord',
  },
  {
    id: 207,
    title: 'Tichondrius',
  },
  {
    id: 208,
    title: 'Tol Barad',
  },
  {
    id: 209,
    title: 'Tortheldrin',
  },
  {
    id: 210,
    title: 'Trollbane',
  },
  {
    id: 211,
    title: 'Turalyon',
  },
  {
    id: 212,
    title: 'Twisting Nether',
  },
  {
    id: 213,
    title: 'Uldaman',
  },
  {
    id: 214,
    title: 'Uldum',
  },
  {
    id: 215,
    title: 'Undermine',
  },
  {
    id: 216,
    title: 'Ursin',
  },
  {
    id: 217,
    title: 'Uther',
  },
  {
    id: 218,
    title: 'Vashj',
  },
  {
    id: 219,
    title: 'Vek\'nilash',
  },
  {
    id: 220,
    title: 'Velen',
  },
  {
    id: 221,
    title: 'Warsong',
  },
  {
    id: 222,
    title: 'Whisperwind',
  },
  {
    id: 223,
    title: 'Wildhammer',
  },
  {
    id: 224,
    title: 'Winterhoof',
  },
  {
    id: 251,
    title: 'Windrunner',
  },
  {
    id: 225,
    title: 'Wyrmrest Accord',
  },
  {
    id: 255,
    title: 'Ysera',
  },
  {
    id: 226,
    title: 'Ysondre',
  },
  {
    id: 227,
    title: 'Zangarmarsh',
  },
  {
    id: 228,
    title: 'Zul\'jin',
  },
  {
    id: 229,
    title: 'Zuluhed',
  },
];

const ServerPopularityModel = {
  [RegionModel.USA.id]: [
    'Area 52',
    'Illidan',
    'Stormrage',
    'Tichondrius',
    'Zul\'jin',
    'Thrall',
    'Jubei\'Thos',
    'Mal\'Ganis',
    'Ragnaros',
    'Sargeras',
    'Proudmoore',
    'Quel\'Thalas',
    'Azralon',
    'Dalaran',
    'Barthilas',
    'Bleeding Hollow',
    'Nagrand',
    'Emerald Dream',
    'Hyjal',
    'Khaz\'goroth',
    'Kil\'jaeden',
    'Kel\'Thuzad',
    'Wyrmrest Accord',
    'Trollbane',
    'Bonechewer',
    'Burning Legion',
    'Silvermoon',
    'Moon Guard',
    'Ner\'zhul',
    'Mug\'thol',
    'Spirestone',
    'Zuluhed',
    'Burning Blade',
    'Nemesis',
    'Sen\'jin',
    'Lightbringer',
    'Arthas',
    'Thunderlord',
    'Cho\'gall',
    'Whisperwind',
    'Khaz Modan',
    'Eredar',
    'Alleria',
    'Aerie Peak',
    'Turalyon',
    'Stormreaver',
    'Drakkari',
    'Aggramar',
    'Suramar',
    'Crushridge',
    'Ysera',
    'Azuremyst',
    'Alterac Mountains',
    'Shadow Council',
    'Bloodhoof',
    'Goldrinn',
    'Maelstrom',
    'Darkspear',
    'Magtheridon',
    'Earthen Ring',
    'Blackhand',
    'Silver Hand',
    'Vek\'nilash',
    'Deathwing',
    'Shu\'halo',
    'Uther',
    'Llane',
    'Doomhammer',
    'Rexxar',
    'Alexstrasza',
    'Shattered Hand',
    'Feathermoon',
    'Argent Dawn',
    'Bladefist',
    'Shadowmoon',
    'Gallywix',
    'Draenor',
    'Greymane',
    'Shandris',
    'Ravencrest',
    'Dragonblight',
    'Kilrogg',
    'Kirin Tor',
  ],
  [RegionModel.EU.id]: [
    'Draenor',
    'Silvermoon',
    'Kazzak',
    'Гордунни',
    'Tarren Mill',
    'Twisting Nether',
    'Ревущий фьорд',
    'Hyjal',
    'Mal\'Ganis',
    'Ragnaros',
    'Свежеватель Душ',
    'Ravencrest',
    'Blackmoore',
    'Sanguino',
    'Antonidas',
    'Blackrock',
    'Kargath',
    'Drak\'thul',
    'Al\'Akir',
    'Stormscale',
    'Argent Dawn',
    'Dalaran',
    'Dun Modr',
    'Пиратская Бухта',
    'Ysondre',
    'Eredar',
    'Grim Batol',
    'Разувий',
    'Defias Brotherhood',
    'Well of Eternity',
    'Sylvanas',
    'Confrérie du Thorium',
    'Archimonde',
    'Doomhammer',
    'Outland',
    'Kilrogg',
    'Nemesis',
    'The Maelstrom',
    'Magtheridon',
    'Вечная Песня',
    'Azjol-Nerub',
    'Stormreaver',
    'Король-лич',
    'Alleria',
    'Дракономор',
    'Shattered Hand',
    'Elune',
    'Garrosh',
    'Eonar',
    'Khaz Modan',
    'Malfurion',
    'Ясеневый лес',
    'Alexstrasza',
    'Anub\'arak',
    'Uldaman',
    'Zirkel des Cenarius',
    'Emerald Dream',
    'Frostwolf',
    'Tyrande',
    'Destromath',
    'Lothar',
    'Thunderhorn',
    'Chamber of Aspects',
    'Frostwhisper',
    'Shadowsong',
    'Sunstrider',
    'Sargeras',
    'Arthas',
    'Exodar',
    'Aegwynn',
    'Aggramar',
    'Азурегос',
    'Kael\'Thas',
    'Dun Morogh',
    'Kult der Verdammten',
    'Bloodhoof',
    'Страж смерти',
    'Alonsus',
    'Moonglade',
    'Twilight\'s Hammer',
    'Onyxia',
    'Stormrage',
    'Chants éternels',
    'Anetheron',
    'Khaz\'goroth',
    'Lightbringer',
    'Nordrassil',
    'Medivh',
    'Area 52',
    'Ysera',
    'Die Aldor',
    'Illidan',
  ],
};

// eslint-disable-next-line import/prefer-default-export
export { ServerModel, ServerPopularityModel };
